/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

var g = require("lexical");

function r(c) {
  var h = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  if (c) return !1;
  c = t();
  h && (c = c.trim());
  return "" === c;
}

function t() {
  return g.$getRoot().getTextContent();
}

function u(c) {
  if (!r(c, !1)) return !1;
  c = g.$getRoot().getChildren();
  var h = c.length;
  if (1 < h) return !1;

  for (var e = 0; e < h; e++) {
    var b = c[e];
    if (g.$isDecoratorNode(b)) return !1;

    if (g.$isElementNode(b)) {
      if (!g.$isParagraphNode(b) || 0 !== b.__indent) return !1;
      b = b.getChildren();
      var n = b.length;

      for (var q = 0; q < n; q++) {
        if (!g.$isTextNode(b[e])) return !1;
      }
    }
  }

  return !0;
}

exports.$canShowPlaceholder = u;

exports.$canShowPlaceholderCurry = function (c) {
  return function () {
    return u(c);
  };
};

exports.$findTextIntersectionFromCharacters = function (c, h) {
  var b = c.getFirstChild();
  c = 0;

  a: for (; null !== b;) {
    if (g.$isElementNode(b)) {
      var e = b.getFirstChild();

      if (null !== e) {
        b = e;
        continue;
      }
    } else if (g.$isTextNode(b)) {
      e = b.getTextContentSize();
      if (c + e > h) return {
        node: b,
        offset: h - c
      };
      c += e;
    }

    e = b.getNextSibling();
    if (null !== e) b = e;else {
      for (b = b.getParent(); null !== b;) {
        e = b.getNextSibling();

        if (null !== e) {
          b = e;
          continue a;
        }

        b = b.getParent();
      }

      break;
    }
  }

  return null;
};

exports.$isRootTextContentEmpty = r;

exports.$isRootTextContentEmptyCurry = function (c, h) {
  return function () {
    return r(c, h);
  };
};

exports.$rootTextContent = t;

exports.registerLexicalTextEntity = function (c, h, b, e) {
  var n = function n(a) {
    var d = g.$createTextNode(a.getTextContent());
    d.setFormat(a.getFormat());
    a.replace(d);
  },
      q = c.registerNodeTransform(g.TextNode, function (a) {
    if (a.isSimpleText()) {
      var d = a.getPreviousSibling(),
          l = a.getTextContent(),
          m = a;

      if (g.$isTextNode(d)) {
        var k = d.getTextContent(),
            f = h(k + l);

        if (d instanceof b) {
          if (null === f || 0 !== d.getLatest().__mode) {
            n(d);
            return;
          }

          f = f.end - k.length;

          if (0 < f) {
            m = l.slice(0, f);
            m = k + m;
            d.select();
            d.setTextContent(m);
            f === l.length ? a.remove() : (d = l.slice(f), a.setTextContent(d));
            return;
          }
        } else if (null === f || f.start < k.length) return;
      }

      for (;;) {
        var _m$splitText, _m$splitText2, _m$splitText3, _m$splitText4;

        a = h(l);
        l = f = null === a ? "" : l.slice(a.end);

        if ("" === f) {
          if (k = m.getNextSibling(), g.$isTextNode(k)) if (f = m.getTextContent() + k.getTextContent(), f = h(f), null === f) {
            k instanceof b ? n(k) : k.markDirty();
            break;
          } else if (0 !== f.start) break;
        } else if (k = h(f), null !== k && 0 === k.start) break;

        if (null === a) break;
        if (0 === a.start && g.$isTextNode(d) && d.isTextEntity()) continue;
        var p = void 0;
        0 === a.start ? (_m$splitText = m.splitText(a.end), _m$splitText2 = _slicedToArray(_m$splitText, 2), p = _m$splitText2[0], m = _m$splitText2[1], _m$splitText) : (_m$splitText3 = m.splitText(a.start, a.end), _m$splitText4 = _slicedToArray(_m$splitText3, 3), p = _m$splitText4[1], m = _m$splitText4[2], _m$splitText3);
        a = e(p);
        a.setFormat(p.getFormat());
        p.replace(a);
        if (null == m) break;
      }
    }
  });

  c = c.registerNodeTransform(b, function (a) {
    var d = a.getTextContent();
    var l = h(d);
    null === l || 0 !== l.start ? n(a) : d.length > l.end ? a.splitText(l.end) : (d = a.getPreviousSibling(), g.$isTextNode(d) && d.isTextEntity() && (n(d), n(a)), d = a.getNextSibling(), g.$isTextNode(d) && d.isTextEntity() && (n(d), a instanceof b && n(a)));
  });
  return [q, c];
};